module.exports = __webpack_public_path__ + "img/swipe-img2.efa8bcdf.png";